// extracted by mini-css-extract-plugin
module.exports = {"overlay":"_1JbQTgvSIun6KzTMOfiph0","background":"_15jRjNeY_Y3MQriJrEEs_N","body":"_2258L6ZSkw_rlZ9_oS_d2N","footer":"lw8MAmOaiCgZEQvD4vaOO","label":"_1xcFIPVlECeiz6uV1k7c1E"};